import { Badge, Box, Button, HStack } from "@chakra-ui/react";

export interface FilterChipOption<V extends string> {
  value: V;
  label: string;
  dotColor?: string;
}

interface FilterChipsProps<V extends string> {
  options: FilterChipOption<V>[];
  value: V;
  onChange: (value: V) => void;
  counts?: Partial<Record<V, number>>;
}

export const FilterChips = <V extends string>({
  options,
  value,
  onChange,
  counts,
}: FilterChipsProps<V>) => (
  <HStack gap={1.5} flexWrap="wrap">
    {options.map((option) => {
      const active = value === option.value;
      const count = counts?.[option.value];
      return (
        <Button
          key={option.value}
          size="xs"
          rounded="full"
          px={3}
          variant={active ? "solid" : "outline"}
          colorPalette={active ? "brand" : "gray"}
          onClick={() => onChange(option.value)}
          aria-pressed={active}
        >
          {option.dotColor && (
            <Box
              as="span"
              boxSize="2"
              rounded="full"
              bg={option.dotColor}
              borderWidth={active ? "1px" : 0}
              borderColor="whiteAlpha.700"
            />
          )}
          {option.label}
          {count !== undefined && (
            <Badge
              size="xs"
              rounded="full"
              variant={active ? "solid" : "subtle"}
              colorPalette={active ? "whiteAlpha" : "gray"}
              bg={active ? "whiteAlpha.300" : undefined}
              color={active ? "white" : undefined}
            >
              {count}
            </Badge>
          )}
        </Button>
      );
    })}
  </HStack>
);
